import { DestinationEntrance } from "./application-route-helpers";
import type { AppScreen } from "./application-route-types";
import { lazyScreen } from "./lazy-screen";

const DeviceSecurityDevice = lazyScreen(() => import("./device-security"), "DeviceSecurityDevice");
const DeviceSecurityDevices = lazyScreen(
  () => import("./device-security"),
  "DeviceSecurityDevices",
);
const DeviceSecurityMine = lazyScreen(() => import("./device-security"), "DeviceSecurityMine");
const DeviceSecurityPolicy = lazyScreen(() => import("./device-security"), "DeviceSecurityPolicy");
const MobilityAssignmentEndorsements = lazyScreen(
  () => import("./mobility"),
  "MobilityAssignmentEndorsements",
);
const MobilityAssignmentsManaged = lazyScreen(
  () => import("./mobility"),
  "MobilityAssignmentsManaged",
);
const MobilityAssignmentsMine = lazyScreen(() => import("./mobility"), "MobilityAssignmentsMine");
const MobilityCatalogue = lazyScreen(() => import("./mobility"), "MobilityCatalogue");
const MobilityInterests = lazyScreen(() => import("./mobility"), "MobilityInterests");
const MobilityMatch = lazyScreen(() => import("./mobility"), "MobilityMatch");
const MobilityOpportunityCorrection = lazyScreen(
  () => import("./mobility"),
  "MobilityOpportunityCorrection",
);
const MobilityOpportunityCreate = lazyScreen(
  () => import("./mobility"),
  "MobilityOpportunityCreate",
);
const MobilityOpportunityExpressions = lazyScreen(
  () => import("./mobility"),
  "MobilityOpportunityExpressions",
);
const MobilityOwned = lazyScreen(() => import("./mobility"), "MobilityOwned");
const MobilityPreferences = lazyScreen(() => import("./mobility"), "MobilityPreferences");
const LearningCatalogue = lazyScreen(() => import("./learning"), "LearningCatalogue");
const LearningOwnApplications = lazyScreen(
  () => import("./learning/own-applications"),
  "LearningOwnApplications",
);
const LearningActivityReport = lazyScreen(
  () => import("./learning/activity-report"),
  "LearningActivityReport",
);
const LearningDetail = lazyScreen(() => import("./learning"), "LearningDetail");
const LearningCategoryDetail = lazyScreen(() => import("./learning"), "LearningCategoryDetail");
const CalibrationPreparations = lazyScreen(
  () => import("./performance-calibration-sessions"),
  "CalibrationPreparations",
);
const CalibrationPreparationDetail = lazyScreen(
  () => import("./performance-calibration-sessions"),
  "CalibrationPreparationDetail",
);
const Performance = lazyScreen(() => import("./performance"), "Performance");
const PerformanceGoalDetail = lazyScreen(() => import("./performance"), "PerformanceGoalDetail");
const PerformanceGoals = lazyScreen(() => import("./performance"), "PerformanceGoals");
const PerformanceGoalSetDetail = lazyScreen(
  () => import("./performance-goal-sets"),
  "PerformanceGoalSetDetail",
);
const PerformanceGoalLibrary = lazyScreen(
  () => import("./performance-goal-library"),
  "PerformanceGoalLibrary",
);
const PerformanceGoalLibraryDetail = lazyScreen(
  () => import("./performance-goal-library"),
  "PerformanceGoalLibraryDetail",
);
const PerformanceSharedObjectiveDetail = lazyScreen(
  () => import("./performance-shared-objectives"),
  "PerformanceSharedObjectiveDetail",
);
const PerformanceGoalPlanDetail = lazyScreen(
  () => import("./performance-goal-plans"),
  "PerformanceGoalPlanDetail",
);
const PerformanceReviews = lazyScreen(() => import("./performance"), "PerformanceReviews");
const PerformanceReports = lazyScreen(() => import("./performance-reports"), "PerformanceReports");
const PerformanceAchievements = lazyScreen(
  () => import("./performance-continuous"),
  "PerformanceAchievements",
);
const PerformanceCheckIns = lazyScreen(
  () => import("./performance-continuous"),
  "PerformanceCheckIns",
);
const PerformanceFeedback = lazyScreen(
  () => import("./performance-continuous"),
  "PerformanceFeedback",
);
const PerformanceOneToOnes = lazyScreen(
  () => import("./performance-continuous"),
  "PerformanceOneToOnes",
);
const PerformanceAchievementDetail = lazyScreen(
  () => import("./performance-continuous-detail"),
  "PerformanceAchievementDetail",
);
const PerformanceCheckInDetail = lazyScreen(
  () => import("./performance-continuous-detail"),
  "PerformanceCheckInDetail",
);
const PerformanceFeedbackDetail = lazyScreen(
  () => import("./performance-continuous-detail"),
  "PerformanceFeedbackDetail",
);
const PerformanceOneToOneMeeting = lazyScreen(
  () => import("./performance-continuous-detail"),
  "PerformanceOneToOneMeeting",
);
const PerformanceOneToOneRelationship = lazyScreen(
  () => import("./performance-continuous-detail"),
  "PerformanceOneToOneRelationship",
);
const PerformanceContribution = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContribution",
);
const PerformanceContributionInvite = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContributionInvite",
);
const PerformanceContributionNomination = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContributionNomination",
);
const PerformanceContributionNominations = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContributionNominations",
);
const PerformanceContributionRegister = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContributionRegister",
);
const PerformanceContributionReplacement = lazyScreen(
  () => import("./performance-contribution"),
  "PerformanceContributionReplacement",
);
const PerformanceCycle = lazyScreen(() => import("./performance-cycle"), "PerformanceCycle");
const PerformanceCycleSetup = lazyScreen(
  () => import("./performance-cycle"),
  "PerformanceCycleSetup",
);
const PerformancePacket = lazyScreen(() => import("./performance-packet"), "PerformancePacket");
const PerformanceReview = lazyScreen(() => import("./performance-review"), "PerformanceReview");

export const TALENT_SCREENS: readonly AppScreen[] = [
  {
    path: "/performance",
    render: ({ state }) => <DestinationEntrance at="/performance" state={state} />,
  },
  {
    path: "/performance/work",
    render: ({ state }) => (
      <Performance
        personId={state.riksu.person?.person_id ?? null}
        roles={state.riksu.roles ?? []}
        surface="work"
      />
    ),
  },
  {
    path: "/performance/activity",
    render: ({ state }) => (
      <Performance
        personId={state.riksu.person?.person_id ?? null}
        roles={state.riksu.roles ?? []}
        surface="activity"
      />
    ),
  },
  {
    path: "/trainings",
    render: ({ state }) => (
      <LearningCatalogue
        roles={state.riksu.roles ?? []}
        recommendationsEnabled={
          state.riksu.modules.includes("performance") && Boolean(state.riksu.person)
        }
      />
    ),
  },
  {
    path: "/trainings/applications",
    render: () => <LearningOwnApplications />,
  },
  {
    path: "/trainings/reports",
    render: () => <LearningActivityReport />,
  },
  {
    path: "/trainings/admin",
    render: ({ state }) => <LearningCatalogue roles={state.riksu.roles ?? []} managing />,
  },
  {
    path: "/trainings/categories/:category_id",
    render: ({ state }) => <LearningCategoryDetail roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/trainings/:course_id",
    render: ({ state }) => (
      <LearningDetail
        roles={state.riksu.roles ?? []}
        personId={state.riksu.person?.person_id ?? null}
      />
    ),
  },
  {
    path: "/mobility",
    render: ({ state }) => <DestinationEntrance at="/mobility" state={state} />,
  },
  {
    path: "/mobility/opportunities",
    render: ({ state }) => <MobilityCatalogue personId={state.riksu.person?.person_id ?? null} />,
  },
  {
    path: "/mobility/opportunities/:opportunity_id/match",
    render: ({ state }) => <MobilityMatch personId={state.riksu.person?.person_id ?? null} />,
  },
  {
    path: "/mobility/preferences",
    render: ({ state }) => <MobilityPreferences personId={state.riksu.person?.person_id ?? null} />,
  },
  {
    path: "/mobility/interests",
    render: ({ state }) => <MobilityInterests personId={state.riksu.person?.person_id ?? null} />,
  },
  {
    path: "/mobility/owned",
    render: ({ state }) => <MobilityOwned personId={state.riksu.person?.person_id ?? null} />,
  },
  {
    path: "/mobility/owned/new",
    render: ({ state }) => (
      <MobilityOpportunityCreate personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/mobility/owned/:opportunity_id/correct",
    render: ({ state }) => (
      <MobilityOpportunityCorrection personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/mobility/owned/:opportunity_id/expressions",
    render: ({ state }) => (
      <MobilityOpportunityExpressions personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/mobility/assignments/mine",
    render: ({ state }) => (
      <MobilityAssignmentsMine personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/mobility/assignments/managed",
    render: ({ state }) => (
      <MobilityAssignmentsManaged personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/mobility/assignments/endorsements",
    render: ({ state }) => (
      <MobilityAssignmentEndorsements personId={state.riksu.person?.person_id ?? null} />
    ),
  },
  {
    path: "/device-security/mine",
    render: () => <DeviceSecurityMine />,
  },
  {
    path: "/device-security",
    render: ({ state }) => <DestinationEntrance at="/device-security" state={state} />,
  },
  {
    path: "/device-security/devices",
    render: () => <DeviceSecurityDevices />,
  },
  {
    path: "/device-security/devices/:asset_id",
    render: () => <DeviceSecurityDevice />,
  },
  {
    path: "/device-security/policy",
    render: ({ state }) => <DeviceSecurityPolicy roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/goals",
    render: ({ state }) => (
      <PerformanceGoals
        personId={state.riksu.person?.person_id ?? null}
        roles={state.riksu.roles ?? []}
      />
    ),
  },
  {
    path: "/performance/goals/sets/:set_id",
    render: () => <PerformanceGoalSetDetail />,
  },
  {
    path: "/performance/goals/library",
    render: ({ state }) => <PerformanceGoalLibrary roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/goals/library/:item_id",
    render: ({ state }) => <PerformanceGoalLibraryDetail roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/goals/objectives/:objective_id",
    render: ({ state }) => <PerformanceSharedObjectiveDetail roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/goals/plans/:plan_id",
    render: ({ state }) => <PerformanceGoalPlanDetail roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/goals/:goal_id",
    render: ({ state }) => (
      <PerformanceGoalDetail
        personId={state.riksu.person?.person_id ?? null}
        roles={state.riksu.roles ?? []}
      />
    ),
  },
  {
    path: "/performance/cycles",
    render: ({ state }) => <PerformanceReviews roles={state.riksu.roles ?? []} surface="cycles" />,
  },
  { path: "/performance/calibration", render: () => <CalibrationPreparations /> },
  {
    path: "/performance/reports",
    render: ({ state }) => <PerformanceReports roles={state.riksu.roles ?? []} />,
  },
  { path: "/performance/calibration/:session_id", render: () => <CalibrationPreparationDetail /> },
  {
    path: "/performance/cycles/:cycle_id",
    render: ({ state }) => <PerformanceCycle roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/cycles/:cycle_id/setup/:step",
    render: ({ state }) => <PerformanceCycleSetup roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/reviews",
    render: ({ state }) => (
      <PerformanceReviews roles={state.riksu.roles ?? []} surface="assignments" />
    ),
  },
  {
    path: "/performance/reviews/:review_id",
    render: () => <PerformanceReview />,
  },
  {
    path: "/performance/review-participants/:participant_id/contributors",
    render: ({ state }) => <PerformanceContributionRegister roles={state.riksu.roles ?? []} />,
  },
  {
    path: "/performance/review-participants/:participant_id/contributors/new/:kind",
    render: () => <PerformanceContributionInvite />,
  },
  {
    path: "/performance/review-participants/:participant_id/nominations",
    render: () => <PerformanceContributionNominations />,
  },
  {
    path: "/performance/nominations/:nomination_id",
    render: () => <PerformanceContributionNomination />,
  },
  {
    path: "/performance/contributions",
    render: ({ state }) => (
      <PerformanceReviews roles={state.riksu.roles ?? []} surface="contributions" />
    ),
  },
  {
    path: "/performance/contributions/:invitation_id",
    render: () => <PerformanceContribution />,
  },
  {
    path: "/performance/contributions/:invitation_id/replacement",
    render: () => <PerformanceContributionReplacement />,
  },
  {
    path: "/performance/check-ins",
    render: () => <PerformanceCheckIns />,
  },
  {
    path: "/performance/check-ins/:check_in_id",
    render: () => <PerformanceCheckInDetail />,
  },
  {
    path: "/performance/one-to-ones",
    render: () => <PerformanceOneToOnes />,
  },
  {
    path: "/performance/one-to-ones/:relationship_id",
    render: () => <PerformanceOneToOneRelationship />,
  },
  {
    path: "/performance/one-to-ones/:relationship_id/meetings/:meeting_id",
    render: () => <PerformanceOneToOneMeeting />,
  },
  {
    path: "/performance/achievements",
    render: () => <PerformanceAchievements />,
  },
  {
    path: "/performance/achievements/:achievement_id",
    render: () => <PerformanceAchievementDetail />,
  },
  {
    path: "/performance/feedback/received",
    render: () => <PerformanceFeedback surface="received" />,
  },
  {
    path: "/performance/feedback/requested",
    render: () => <PerformanceFeedback surface="requested" />,
  },
  {
    path: "/performance/feedback/received/:request_id",
    render: () => <PerformanceFeedbackDetail />,
  },
  {
    path: "/performance/feedback/received/:request_id/responses/:response_id",
    render: () => <PerformanceFeedbackDetail />,
  },
  {
    path: "/performance/feedback/requested/:request_id",
    render: () => <PerformanceFeedbackDetail />,
  },
  {
    path: "/performance/packets",
    render: ({ state }) => <PerformanceReviews roles={state.riksu.roles ?? []} surface="packets" />,
  },
  {
    path: "/performance/packets/:packet_id",
    render: () => <PerformancePacket />,
  },
];
